module.exports = __webpack_public_path__ + "img/2012-08-18 09.14.13.4152d1a8.jpg";